import React from 'react';
import { Icon } from "antd";
import GoogleMapReact from 'google-map-react';

const MapaVendasPage = ({ latitude, longitude }) => {

  const points = [
    { id: 1, title: "Casa Daniel", lat: -24.034061, lng: -52.363037 },
    { id: 2, title: "Expresso Nordeste", lat: -24.0507012, lng: -52.3753922 },
    { id: 3, title: "Cantina Dicolli", lat: -24.038062, lng: -52.369250 }
  ];

  const MyMarker = ({ text, tooltip }) => (
    <div style={{ cursor: 'pointer' }}>
      <span title={tooltip}>
        {/* {tooltip} */}
        {/* <Icon type="pushpin" style={{ fontSize: 40, color: "red" }} /> */}
        <Icon type="environment" style={{ fontSize: 40, color: "red" }} />
      </span>
    </div>
  );

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: 'AIzaSyDgE68pxurJkFh52zzpYHxvKjYghvA0Vj0' }}
        defaultCenter={{ lat: -24.034061, lng: -52.363037 }}
        defaultZoom={14}
        yesIWantToUseGoogleMapApiInternals={true}
        options={{
          disableDefaultUI: true,
          mapTypeControl: true,
          streetViewControl: true,
          // styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'on' }] }],

          // styles: [
          //   { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
          //   { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
          //   { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
          //   {
          //     featureType: "administrative.locality",
          //     elementType: "labels.text.fill",
          //     stylers: [{ color: "#d59563" }],
          //   },
          //   {
          //     featureType: "poi",
          //     elementType: "labels.text.fill",
          //     stylers: [{ color: "#d59563" }],
          //   },
          //   {
          //     featureType: "poi.park",
          //     elementType: "geometry",
          //     stylers: [{ color: "#263c3f" }],
          //   },
          //   {
          //     featureType: "poi.park",
          //     elementType: "labels.text.fill",
          //     stylers: [{ color: "#6b9a76" }],
          //   },
          //   {
          //     featureType: "road",
          //     elementType: "geometry",
          //     stylers: [{ color: "#38414e" }],
          //   },
          //   {
          //     featureType: "road",
          //     elementType: "geometry.stroke",
          //     stylers: [{ color: "#212a37" }],
          //   },
          //   {
          //     featureType: "road",
          //     elementType: "labels.text.fill",
          //     stylers: [{ color: "#9ca5b3" }],
          //   },
          //   {
          //     featureType: "road.highway",
          //     elementType: "geometry",
          //     stylers: [{ color: "#746855" }],
          //   },
          //   {
          //     featureType: "road.highway",
          //     elementType: "geometry.stroke",
          //     stylers: [{ color: "#1f2835" }],
          //   },
          //   {
          //     featureType: "road.highway",
          //     elementType: "labels.text.fill",
          //     stylers: [{ color: "#f3d19c" }],
          //   },
          //   {
          //     featureType: "transit",
          //     elementType: "geometry",
          //     stylers: [{ color: "#2f3948" }],
          //   },
          //   {
          //     featureType: "transit.station",
          //     elementType: "labels.text.fill",
          //     stylers: [{ color: "#d59563" }],
          //   },
          //   {
          //     featureType: "water",
          //     elementType: "geometry",
          //     stylers: [{ color: "#17263c" }],
          //   },
          //   {
          //     featureType: "water",
          //     elementType: "labels.text.fill",
          //     stylers: [{ color: "#515c6d" }],
          //   },
          //   {
          //     featureType: "water",
          //     elementType: "labels.text.stroke",
          //     stylers: [{ color: "#17263c" }],
          //   },
          // ],
        }}
      >
        {points.map(({ lat, lng, id, title }) => {
          return (
            <MyMarker
              key={id}
              lat={lat}
              lng={lng}
              text={id}
              tooltip={title}
            />
          );
        })}
      </GoogleMapReact>
    </div >
  );
};

export default MapaVendasPage;


// WEBPACK FOOTER //
// ./src/components/MapaVendasForm.js